import * as React from "react";

function ChevronUp(props) {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.333 6.677L3.866 11 3 10.162 8.333 5l5.334 5.162L12.8 11 8.333 6.677z"
      />
    </svg>
  );
}

export default ChevronUp;
